<template>
  <div class="setting-body">
    <div class="setting-body-title m-b-20">{{ routerTitle }}</div>
    <div class="security-setting">
      <change-password @afterChange="handleFunForMesChange" />
      <change-mobile @afterChange="handleFunForMesChange" />

      <!--微信绑定-->
      <div class="mes-list">
        <div class="list-left">
          <p>微信绑定</p>
          <p v-if="wxMpOpenid">已绑定微信：{{ wechatNickname }}</p>
          <p v-else>未绑定微信</p>
        </div>

        <bind-wechat type="textBtn" />
      </div>
    </div>
  </div>
</template>

<script>
import ChangePassword from '@/components/PersonalCenter/ChangePassword'
import ChangeMobile from '@/components/PersonalCenter/ChangeMobile'
import BindWechat from '@/components/PersonalCenter/BindWechat'

// 引入api接口
import { mapState, mapActions, mapGetters } from 'vuex'
import personalMixin from '@/views/personal-center/personalMixin'

export default {
  name: 'SecuritySetting',

  components: { ChangeMobile, ChangePassword, BindWechat },

  mixins: [personalMixin],

  data() {
    return {
      securityInfo: {}
    }
  },

  computed: {
    ...mapState('company', ['supervise']),
    ...mapState('user', ['wxMpOpenid', 'wechatNickname']),
    ...mapGetters('system', ['platformConfig'])
  },

  methods: {
    ...mapActions('user', ['logout', 'resetUser']),

    // 信息修改成功后的处理函数（包括密码和手机号）
    handleFunForMesChange(tipMes) {
      this.$alert(tipMes, '系统提示', {
        showClose: false,
        confirmButtonText: '确定',
        type: 'success',
        callback: action => {
          this.logout()
            .then(res => {
              // 防止当前页面有beforeunload的阻拦
              window.onbeforeunload = null
              window.location.href = this.platformConfig.loginUrl
            })
            .catch(err => {
              this.resetUser().then(res => {
                // 防止当前页面有beforeunload的阻拦
                window.onbeforeunload = null
                window.location.href = this.platformConfig.loginUrl
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-body {
  width: 1030px;
  padding: 20px;
  background-color: $white-color;
  overflow: hidden;
  position: relative;
  border-radius: 4px;

  .setting-body-title {
    text-align: left;
    font-size: 20px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 25px;
      background-color: $primary-color;
      vertical-align: bottom;
      margin-right: 10px;
    }
  }

  .mes-list {
    display: flex;
    align-items: center;
    margin-top: pixel-to-rem($n: 20);
    border-bottom: 1px solid $info-fourth-color;

    .list-left {
      flex: 1;
      text-align: left;

      p:first-child {
        font-size: 16px;
        margin: 10px 0;
      }
      p:last-child {
        color: $text-third-color;
      }
    }
  }
}
</style>
